import React from "react";
import loading from "../../img/loading.gif";

const LoadingSpinner = ({ width }) => {
  return (
    <img
      style={{ width: typeof width !== "undefined" ? width : "25%" }}
      src={loading}
      alt=""
      className="loading-spinner"
    />
  );
};

export default LoadingSpinner;
